export type InterviewerSessionTarget = {
  profileId?: string | null
  opportunityId?: string | null
  label?: string | null
  interviewId?: string | null
  liveSessionId?: string | null
}

/** Path to create or resume a Daily interview room. Callers may wrap with thread preservation. */
export function interviewerSessionHref(target: InterviewerSessionTarget): string {
  const params = new URLSearchParams()
  if (target.profileId) params.set('profileId', target.profileId)
  if (target.opportunityId) params.set('opportunityId', target.opportunityId)
  if (target.label) params.set('label', target.label)
  if (target.interviewId) params.set('interviewId', target.interviewId)
  const qs = params.toString()
  const path = target.liveSessionId
    ? `/interviewer/session/${target.liveSessionId}`
    : '/interviewer/session'
  return qs ? `${path}?${qs}` : path
}
